module.exports = __webpack_public_path__ + "img/login-img.fd92cd41.png";